module.exports = __webpack_public_path__ + "static/media/icon-ecommerce.18e29433.svg";